// extracted by mini-css-extract-plugin
export var locationCard = "_gz-0";